<template>
  <div ref="videoContainer" style="width:100%;height:100%">
    <!-- vue指令禁用右键 -->
    <div
      @contextmenu.prevent=""
      style="padding:0.5rem;width:calc( 100% - 1rem);height:calc( 100% - 4.4rem);background:#8BDAFB;border-radius:1rem"
    >
      <div style="width:100%;height:100%">
        <div
          style="width:100%;height:100%"
          :style="
            videoOptions.full_screen
              ? 'width:100vw;height:100vh;position:fixed;top:0;left:0;z-index:999'
              : ''
          "
        >
          <div style="position:relative;width:100%;height:100%">
            <!--                        :loop="videoOptions.loop"-->
            <video
              ref="class-video"
              :poster="videoOptions.poster"
              :src="videoOptions.src"
              controlslist="nodownload nofullscreen"
              :muted="videoOptions.muted"
              preload
              style="outline:none;border:none;background:rgb(93,172,230)"
              :style="videoOptions.full_screen ? '' : 'border-radius:0.7rem'"
              width="100%;"
              height="100%"
              @click="videoClick"
            ></video>
            <div
              v-if="
                videoOptions.full_screen && videoOptions.full_screen_bar_show
              "
              class="fadeIn"
              style="position:absolute;height:5rem;border-radius:2rem 2rem 0 0;background:rgba(0,0,0,0.5);width:100%;bottom:0;left:0"
            >
              <div style="padding:0 3.5rem;height:100%" class="flexAc">
                <div style="flex-grow:1" class="flexBetween">
                  <div style="width:calc( 100% - 10rem )">
                    <!-- :show-tooltip="!videoOptions.upd_process"  -->
                    <el-slider
                      v-model="videoOptions.played_percent"
                      :disabled="!videoOptions.process_dragable"
                      :format-tooltip="videoOptions.process_text_formatter"
                      :max="10000"
                      @mousedown.native="videoOptions.upd_process = false"
                      @mouseup.native="videoOptions.upd_process = true"
                      @change="videoProcessChange"
                    ></el-slider>
                  </div>
                  <div
                    style="width:8rem;padding:0 1rem;font-size:1.4rem;color:#ffffff;"
                  >
                    {{ videoOptions.curr_time
                    }}<span style="margin:0 0.2rem">/</span
                    >{{ videoOptions.total_time }}
                  </div>
                </div>
                <div class="flexAc">
                  <img
                    :src="
                      videoOptions.palying
                        ? require('../assets/icon_pause_white.png')
                        : require('../assets/icon_play_white.png')
                    "
                    style="width:2.2rem;margin-right:0.5rem;cursor: pointer;"
                    @click="videoBarClick('play')"
                  />
                  <img
                    src="../assets/icon_min_white.png"
                    style="width:2.2rem;margin-right:0.5rem;cursor: pointer"
                    @click="videoBarClick('maxmin')"
                  />
                  <el-popover 
                    ref="volumePopoverFullscreen" 
                    placement="top" 
                    trigger="click"
                    width="180"
                    popper-class="volume-popover-fullscreen"
                  >
                    <div class="volume-control-panel">
                      <div class="volume-header">
                        <div class="volume-icon-wrapper" @click="toggleMute">
                          <img
                            :src="
                              videoOptions.muted || videoOptions.volume === 0
                                ? require('../assets/icon_muted_white.png')
                                : require('../assets/icon_voice_white.png')
                            "
                            class="volume-icon"
                          />
                        </div>
                        <span class="volume-text">音量</span>
                        <span class="volume-percentage">{{ videoOptions.volume }}%</span>
                      </div>
                      <div class="volume-slider-wrapper">
                        <el-slider
                          v-model="videoOptions.volume"
                          :min="0"
                          :max="100"
                          :show-tooltip="false"
                          @input="setVolume"
                          class="volume-slider"
                        ></el-slider>
                      </div>
                    </div>
                    <img
                      slot="reference"
                      :src="
                        videoOptions.muted || videoOptions.volume === 0
                          ? require('../assets/icon_muted_white.png')
                          : require('../assets/icon_voice_white.png')
                      "
                      style="width:2.2rem;margin-right:0.5rem;cursor: pointer"
                    />
                  </el-popover>
                  <el-popover ref="popoverRef2" placement="top" trigger="click">
                    <div style="display:flex;align-items:center;">
                      <div
                        @click="setPlaybackRate(0.5)"
                        style="cursor: pointer;text-align:center;margin-right:10px"
                        :style="
                          videoOptions.playbackRate == 0.5
                            ? 'color:#16a0e9;font-weight:bold'
                            : ''
                        "
                      >
                        0.5
                      </div>
                      <div
                        @click="setPlaybackRate(0.75)"
                        style="cursor: pointer;text-align:center;margin-right:10px"
                        :style="
                          videoOptions.playbackRate == 0.75
                            ? 'color:#16a0e9;font-weight:bold'
                            : ''
                        "
                      >
                        0.75
                      </div>
                      <div
                        @click="setPlaybackRate(1)"
                        style="cursor: pointer;text-align:center;margin-right:10px"
                        :style="
                          videoOptions.playbackRate == 1
                            ? 'color:#16a0e9;font-weight:bold'
                            : ''
                        "
                      >
                        1
                      </div>
                      <div
                        @click="setPlaybackRate(1.25)"
                        style="cursor: pointer;text-align:center;margin-right:10px"
                        :style="
                          videoOptions.playbackRate == 1.25
                            ? 'color:#16a0e9;font-weight:bold'
                            : ''
                        "
                      >
                        1.25
                      </div>
                      <div
                        @click="setPlaybackRate(1.5)"
                        style="cursor: pointer;text-align:center;margin-right:10px"
                        :style="
                          videoOptions.playbackRate == 1.5
                            ? 'color:#16a0e9;font-weight:bold'
                            : ''
                        "
                      >
                        1.5
                      </div>
                      <div
                        @click="setPlaybackRate(2)"
                        style="cursor: pointer;text-align:center;"
                        :style="
                          videoOptions.playbackRate == 2
                            ? 'color:#16a0e9;font-weight:bold'
                            : ''
                        "
                      >
                        2
                      </div>
                    </div>
                    <div
                      slot="reference"
                      style="width:3.2rem;cursor: pointer;height:2.2rem;border-radius:1.1rem;background:#ffffff;font-size:0.8rem;color:#16a0e9;text-align:center;line-height:2.2rem"
                    >
                      {{ videoOptions.playbackRate == 1 ? "倍X" : ""
                      }}{{ videoOptions.playbackRate }}
                    </div>
                  </el-popover>
                  <el-popover
                    ref="popoverRef4"
                    popper-class="playback-cnt-popover-class"
                    placement="top"
                    trigger="click"
                  >
                    <div style="display:flex;align-items:center;">
                      <div
                        @click="setPlaybackCount(1)"
                        style="cursor: pointer;text-align:center;margin-right:10px"
                        :style="
                          videoOptions.playbackCount == 1
                            ? 'color:#16a0e9;font-weight:bold'
                            : ''
                        "
                      >
                        1
                      </div>
                      <div
                        @click="setPlaybackCount(2)"
                        style="cursor: pointer;text-align:center;margin-right:10px"
                        :style="
                          videoOptions.playbackCount == 2
                            ? 'color:#16a0e9;font-weight:bold'
                            : ''
                        "
                      >
                        2
                      </div>
                      <div
                        @click="setPlaybackCount(3)"
                        style="cursor: pointer;text-align:center;"
                        :style="
                          videoOptions.playbackCount == 3
                            ? 'color:#16a0e9;font-weight:bold'
                            : ''
                        "
                      >
                        3
                      </div>
                    </div>
                    <div
                      slot="reference"
                      style="width:3.2rem;cursor: pointer;height:2.2rem;margin-left:0.5rem;border-radius:1.1rem;background:#ffffff;color:#16a0e9;font-size:0.8rem;text-align:center;line-height:2.2rem"
                    >
                      {{ videoOptions.playbackCount }} 遍
                    </div>
                  </el-popover>
                  <div
                    @click="videoBarClick('list_loop')"
                    style="margin-left:0.5rem;cursor: pointer;width:5rem;
        text-align:center;
        height:2.2rem;font-size:1rem;color:#16a0e9;border-radius:1.1rem;line-height:2.2rem;background:#ffffff"
                  >
                    {{ videoOptions.list_loop ? "自动播放" : "手动播放" }}
                  </div>
                  <!-- <img
                    :src="
                      videoOptions.list_loop
                        ? require('../assets/icon_loop_white.png')
                        : require('../assets/icon_unloop_white.png')
                    "
                    style="width:2.2rem;margin-left:0.5rem;cursor: pointer"
                    @click="videoBarClick('list_loop')"
                  /> -->
                </div>
              </div>
            </div>

            <slot
              v-if="
                videoOptions.full_screen && videoOptions.full_screen_float_show
              "
            ></slot>
            <!-- videoOptions.full_screen &&  -->
            <div
              v-if="videoOptions.full_screen_bar_show && videoOptions.src"
              class="fadeIn flexAc"
              style="position:absolute;top:50%;left:50%;transform: translateX(-50%) translateY(-50%);cursor: pointer;"
            >
              <div
                style="margin-bottom:0.5rem;width:6.3rem;height:6.3rem;margin-right: 2rem;background: rgba(0,0,0,0.55);border-radius: 50%;box-shadow: rgba(0,0,0,0.8) 0 0 0.3rem"
                class="flexCenter"
              >
                <img
                  :src="require('../assets/next_video.png')"
                  style="width:3.3rem;height:3.3rem;transform:rotate(180deg)"
                  @click="playPrevVideo"
                />
              </div>
              <img
                :src="
                  videoOptions.palying
                    ? require('../assets/icon_pause_fullscreen.png')
                    : require('../assets/icon_play_fullscreen.png')
                "
                style="width:6.6rem;height:6.85rem"
                @click="videoBarClick('play')"
              />
              <img
                :src="
                  videoOptions.loop
                    ? require('../assets/icon_loop_selected.png')
                    : require('../assets/icon_loop_unselected.png')
                "
                style="width:6.6rem;height:6.85rem;margin-left: 2rem"
                @click="videoBarClick('loop')"
              />
              <div
                style="margin-bottom:0.5rem;width:6.3rem;height:6.3rem;margin-left: 2rem;background: rgba(0,0,0,0.55);border-radius: 50%;box-shadow: rgba(0,0,0,0.8) 0 0 0.3rem"
                class="flexCenter"
              >
                <img
                  :src="require('../assets/next_video.png')"
                  style="width:3.3rem;height:3.3rem"
                  @click="playNextVideo"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-show="!videoOptions.full_screen"
      style="height:3.4rem;"
      class="flexAc"
    >
      <div style="flex-grow:1" class="flexBetween">
        <div style="width:calc( 100% - 10rem )">
          <el-slider
            v-model="videoOptions.played_percent"
            :disabled="!videoOptions.process_dragable"
            :format-tooltip="videoOptions.process_text_formatter"
            :max="10000"
            @mousedown.native="videoOptions.upd_process = false"
            @mouseup.native="videoOptions.upd_process = true"
            @change="videoProcessChange"
          ></el-slider>
        </div>
        <div style="width:8rem;padding:0 1rem;font-size:1.4rem;color:#16A0E9;">
          {{ videoOptions.curr_time }}<span style="margin:0 0.2rem">/</span
          >{{ videoOptions.total_time }}
        </div>
      </div>
      <div class="flexAc">
        <img
          :src="
            videoOptions.palying
              ? require('../assets/icon_pause.png')
              : require('../assets/icon_play.png')
          "
          style="width:2.2rem;margin-right:0.5rem;cursor: pointer"
          @click="videoBarClick('play')"
        />
        <img
          src="../assets/icon_max.png"
          style="width:2.2rem;margin-right:0.5rem;cursor: pointer"
          @click="videoBarClick('maxmin')"
        />
        <el-popover 
          ref="volumePopover" 
          placement="top" 
          trigger="click"
          width="180"
          popper-class="volume-popover"
        >
          <div class="volume-control-panel">
            <div class="volume-header">
              <div class="volume-icon-wrapper" @click="toggleMute">
                <img
                  :src="
                    videoOptions.muted || videoOptions.volume === 0
                      ? require('../assets/icon_muted.png')
                      : require('../assets/icon_voice.png')
                  "
                  class="volume-icon"
                />
              </div>
              <span class="volume-text">音量</span>
              <span class="volume-percentage">{{ videoOptions.volume }}%</span>
            </div>
            <div class="volume-slider-wrapper">
              <el-slider
                v-model="videoOptions.volume"
                :min="0"
                :max="100"
                :show-tooltip="false"
                @input="setVolume"
                class="volume-slider"
              ></el-slider>
            </div>
          </div>
          <img
            slot="reference"
            :src="
              videoOptions.muted || videoOptions.volume === 0
                ? require('../assets/icon_muted.png')
                : require('../assets/icon_voice.png')
            "
            style="width:2.2rem;margin-right:0.5rem;cursor: pointer"
          />
        </el-popover>
        <el-popover ref="popoverRef1" placement="top" trigger="click">
          <div style="display:flex;align-items:center;">
            <div
              @click="setPlaybackRate(0.5)"
              style="cursor: pointer;text-align:center;margin-right:10px"
              :style="
                videoOptions.playbackRate == 0.5
                  ? 'color:#16a0e9;font-weight:bold'
                  : ''
              "
            >
              0.5
            </div>
            <div
              @click="setPlaybackRate(0.75)"
              style="cursor: pointer;text-align:center;margin-right:10px"
              :style="
                videoOptions.playbackRate == 0.75
                  ? 'color:#16a0e9;font-weight:bold'
                  : ''
              "
            >
              0.75
            </div>
            <div
              @click="setPlaybackRate(1)"
              style="cursor: pointer;text-align:center;margin-right:10px"
              :style="
                videoOptions.playbackRate == 1
                  ? 'color:#16a0e9;font-weight:bold'
                  : ''
              "
            >
              1
            </div>
            <div
              @click="setPlaybackRate(1.25)"
              style="cursor: pointer;text-align:center;margin-right:10px"
              :style="
                videoOptions.playbackRate == 1.25
                  ? 'color:#16a0e9;font-weight:bold'
                  : ''
              "
            >
              1.25
            </div>
            <div
              @click="setPlaybackRate(1.5)"
              style="cursor: pointer;text-align:center;margin-right:10px"
              :style="
                videoOptions.playbackRate == 1.5
                  ? 'color:#16a0e9;font-weight:bold'
                  : ''
              "
            >
              1.5
            </div>
            <div
              @click="setPlaybackRate(2)"
              style="cursor: pointer;text-align:center;"
              :style="
                videoOptions.playbackRate == 2
                  ? 'color:#16a0e9;font-weight:bold'
                  : ''
              "
            >
              2
            </div>
          </div>
          <div
            slot="reference"
            style="width:3.2rem;cursor: pointer;height:2.2rem;border-radius:1.1rem;background:#16a0e9;color:#ffffff;font-size:0.8rem;color:#ffffff;text-align:center;line-height:2.2rem"
          >
            {{ videoOptions.playbackRate == 1 ? "倍X" : ""
            }}{{ videoOptions.playbackRate }}
          </div>
        </el-popover>
        <el-popover
          ref="popoverRef3"
          popper-class="playback-cnt-popover-class"
          placement="top"
          trigger="click"
        >
          <div style="display:flex;align-items:center;">
            <div
              @click="setPlaybackCount(1)"
              style="cursor: pointer;text-align:center;margin-right:10px"
              :style="
                videoOptions.playbackCount == 1
                  ? 'color:#16a0e9;font-weight:bold'
                  : ''
              "
            >
              1
            </div>
            <div
              @click="setPlaybackCount(2)"
              style="cursor: pointer;text-align:center;margin-right:10px"
              :style="
                videoOptions.playbackCount == 2
                  ? 'color:#16a0e9;font-weight:bold'
                  : ''
              "
            >
              2
            </div>
            <div
              @click="setPlaybackCount(3)"
              style="cursor: pointer;text-align:center;"
              :style="
                videoOptions.playbackCount == 3
                  ? 'color:#16a0e9;font-weight:bold'
                  : ''
              "
            >
              3
            </div>
          </div>
          <div
            slot="reference"
            style="width:3.2rem;cursor: pointer;height:2.2rem;border-radius:1.1rem;margin-left:0.5rem;background:#16a0e9;color:#ffffff;font-size:0.8rem;color:#ffffff;text-align:center;line-height:2.2rem"
          >
            {{ videoOptions.playbackCount }} 遍
          </div>
        </el-popover>
        <div
          @click="videoBarClick('list_loop')"
          style="margin-left:0.5rem;cursor: pointer;width:5rem;
        text-align:center;
        height:2.2rem;font-size:1rem;color:#ffffff;border-radius:1.1rem;line-height:2.2rem;background:#16a0e9"
        >
          {{ videoOptions.list_loop ? "自动播放" : "手动播放" }}
        </div>
        <!-- <img
          :src="
            videoOptions.list_loop
              ? require('../assets/icon_loop.png')
              : require('../assets/icon_unloop.png')
          "
          style="width:2.2rem;margin-left:0.5rem;cursor: pointer"
          @click="videoBarClick('list_loop')"
        /> -->
      </div>
    </div>
  </div>
</template>

<script>
let timer = null;
let tick = 0;
function clearTick() {
  tick = 0;
}
export default {
  components: {},
  props: {
    floatVideoListShow: {
      type: Boolean,
      default: false,
    },
    floatStudentsListShow: {
      type: Boolean,
      default: false,
    },
  },
  name: "BottomBar",
  data() {
    return {
      videoOptions: {
        type: "video",
        canplay: false,
        src: "",
        start_at: "00:00:00",
        end_at: "00:00:00",
        poster: require("../assets/class_cover.png"), //封面
        palying: false, //是否播放状态
        muted: false, //是否静音
        volume: 100, //音量大小，0-100
        showVolumeSlider: false, //是否显示音量滑块
        full_screen: false, //是否全屏
        total_time: "00:00", //视频总时长
        curr_time: "00:00", //当前播放时长
        loop: false, //是否循环播放
        list_loop: false,
        process_dragable: false, //是否允许拖动进度条
        played_percent: 0, //进度条位置，0-10000
        playbackRate: 1, //播放倍速
        playbackCount: 1, // 默认播放遍数
        hasPlayedCnt: 0, // 记录当前视频已播放次数
        //进度条tip
        process_text_formatter: (e) => {
          let video = this.$refs["class-video"];
          if (e && video) {
            if (this.videoOptions.type == "video") {
              return this.formatVideoTime((video.duration * e) / 10000);
            } else if (this.videoOptions.type == "logic_seq") {
              let end_at = video.duration;
              end_at =
                this.videoOptions.end_at > end_at
                  ? end_at
                  : this.videoOptions.end_at;
              return this.formatVideoTime(
                ((end_at - this.videoOptions.start_at) * e) / 10000
              );
            }
          }
        },
        upd_process: true, //是否允许palying事件更新进度条，主要是用在拖动改变经度的时候
        full_screen_bar_show: false, //全屏的时候切换工具栏的展示
        full_screen_float_show: false, //全屏时切换视频之上浮层的显示
      },
    };
  },
  computed: {
    list_loop() {
      return this.videoOptions.list_loop;
    },
  },
  watch: {
    list_loop(val) {
      localStorage.setItem("list_loop", val);
    },
  },
  beforeDestroy() {
    if (timer) {
      clearInterval(timer);
    }
    this.$refs["videoContainer"].removeEventListener("mousemove", clearTick);
    this.$refs["videoContainer"].removeEventListener("mousedown", clearTick);
    this.$refs["videoContainer"].removeEventListener("touchstart", clearTick);
    this.$refs["videoContainer"].removeEventListener("touchmove", clearTick);
  },
  mounted() {
    this.initVideoEvent();
    timer = setInterval(() => {
      tick++;
      if (
        tick > 3 &&
        // this.videoOptions.full_screen &&
        !this.floatVideoListShow &&
        !this.floatStudentsListShow
      ) {
        this.videoOptions.full_screen_bar_show = false;
        this.videoOptions.full_screen_float_show = false;
        tick = 0;
      }
    }, 1000);

    this.$refs["videoContainer"].addEventListener("mousemove", clearTick);
    this.$refs["videoContainer"].addEventListener("mousedown", clearTick);
    this.$refs["videoContainer"].addEventListener("touchstart", clearTick);
    this.$refs["videoContainer"].addEventListener("touchmove", clearTick);
  },
  methods: {
    setPlaybackRate(rate) {
      if (rate != this.videoOptions.playbackRate) {
        this.videoOptions.playbackRate = rate;
        let video = this.$refs["class-video"];
        if (video) {
          video.playbackRate = this.videoOptions.playbackRate;
        }
      }
      this.$refs["popoverRef1"] ? this.$refs["popoverRef1"].doClose() : "";
      this.$refs["popoverRef2"] ? this.$refs["popoverRef2"].doClose() : "";
      this.$refs["popoverRef3"] ? this.$refs["popoverRef3"].doClose() : "";
    },
    setPlaybackCount(count) {
      this.videoOptions.playbackCount = count;
      this.$refs["popoverRef3"] ? this.$refs["popoverRef3"].doClose() : "";
      this.$refs["popoverRef4"] ? this.$refs["popoverRef4"].doClose() : "";
    },
    setVolume(volume) {
      // 设置音量
      this.videoOptions.volume = volume;
      let video = this.$refs["class-video"];
      if (video) {
        video.volume = volume / 100;
        // 如果音量大于0，自动取消静音
        if (volume > 0 && this.videoOptions.muted) {
          this.videoOptions.muted = false;
          video.muted = false;
        }
        // 如果音量为0，自动静音
        if (volume === 0) {
          this.videoOptions.muted = true;
          video.muted = true;
        }
      }
    },
    toggleMute() {
      // 切换静音状态
      this.videoOptions.muted = !this.videoOptions.muted;
      let video = this.$refs["class-video"];
      if (video) {
        video.muted = this.videoOptions.muted;
        // 如果取消静音且当前音量为0，设置为50%
        if (!this.videoOptions.muted && this.videoOptions.volume === 0) {
          this.videoOptions.volume = 50;
          video.volume = 0.5;
        }
      }
    },
    playNextVideo() {
      this.$emit("play-next-video", this.videoOptions.list_loop);
    },
    playPrevVideo() {
      this.$emit("play-prev-video");
    },
    exitFullScreen() {
      this.videoOptions.full_screen = false;
    },
    setVideoOptions(src, poster) {
      this.videoOptions.type = "video";
      this.videoOptions.src = src;
      this.videoOptions.poster = poster;
      this.videoOptions.palying = false;
      this.videoOptions.played_percent = 0;
      this.videoOptions.hasPlayedCnt = 0; // 重置播放次数
      this.$refs["class-video"].currentTime = 0;
      // 设置音量
      let video = this.$refs["class-video"];
      if (video) {
        video.volume = this.videoOptions.volume / 100;
        video.muted = this.videoOptions.muted;
      }
      this.play();
    },
    videoClick() {
      this.videoOptions.full_screen_bar_show = !this.videoOptions
        .full_screen_float_show;
      this.videoOptions.full_screen_float_show = !this.videoOptions
        .full_screen_float_show;
    },
    hideFullScreenBar() {
      this.videoOptions.full_screen_bar_show = false;
    },
    videoProcessChange(e) {
      let video = this.$refs["class-video"];
      if (e && video) {
        if (this.videoOptions.type == "video") {
          video.currentTime = (video.duration * e) / 10000;
        } else if (this.videoOptions.type == "logic_seq") {
          let end_at = video.duration;
          end_at =
            this.videoOptions.end_at > end_at
              ? end_at
              : this.videoOptions.end_at;

          let currentTime =
            ((end_at - this.videoOptions.start_at) * e) / 10000 +
            this.videoOptions.start_at;
          currentTime =
            currentTime > video.duration ? video.duration : currentTime;
          video.currentTime = currentTime;
          if (currentTime >= video.duration) {
            this.videoOptions.hasPlayedCnt++; // 增加播放次数计数
            this.pause();
            if (
              this.videoOptions.loop ||
              this.videoOptions.hasPlayedCnt < this.videoOptions.playbackCount
            ) {
              video.currentTime = this.videoOptions.start_at;
              this.play();
            } else if (this.videoOptions.list_loop) {
              this.playNextVideo();
            }
          }
        }
      }
    },
    formatVideoTime(secs) {
      let min = parseInt(secs / 60);
      let sec = parseInt(secs % 60);
      min = min < 10 ? "0" + min : min;
      sec = sec < 10 ? "0" + sec : sec;
      return min + ":" + sec;
    },
    initVideoEvent() {
      let video = this.$refs["class-video"];

      let list_loop = localStorage.getItem("list_loop");
      if (list_loop === "true") {
        this.videoOptions.list_loop = true;
      } else {
        this.videoOptions.list_loop = false;
      }
      // 播放监听
      video.addEventListener("play", () => {
        console.log("play");
        this.videoOptions.palying = true;
        if (this.videoOptions.type == "logic_seq") {
          let video = this.$refs["class-video"];
          let currtime = video.currentTime;
          let end_at = this.videoOptions.end_at;
          end_at = end_at > video.duration ? video.duration : end_at;
          if (currtime > end_at || currtime < this.videoOptions.start_at) {
            video.currentTime = this.videoOptions.start_at;
          }
        }
      });

      // 暂停监听
      video.addEventListener("pause", () => {
        this.videoOptions.palying = false;
      });

      // 目前的播放位置已更改时，播放时间更新
      video.addEventListener("timeupdate", (e) => {
        //更新进度条位置
        if (
          this.videoOptions.upd_process &&
          this.videoOptions.type == "video"
        ) {
          this.videoOptions.curr_time = this.formatVideoTime(
            e.target.currentTime
          );
          this.videoOptions.played_percent = Math.round(
            (e.target.currentTime / e.target.duration) * 10000
          );
        } else if (
          this.videoOptions.upd_process &&
          this.videoOptions.type == "logic_seq"
        ) {
          let start = this.videoOptions.start_at;
          let end = this.videoOptions.end_at;
          end = end > e.target.duration ? e.target.duration : end;

          this.videoOptions.curr_time = this.formatVideoTime(
            e.target.currentTime - parseInt(start)
          );

          this.videoOptions.played_percent = Math.round(
            ((e.target.currentTime - start) / (end - start)) * 10000
          );

          if (e.target.currentTime >= this.videoOptions.end_at) {
            this.videoOptions.hasPlayedCnt++;
            this.pause();
            if (
              this.videoOptions.loop ||
              this.videoOptions.hasPlayedCnt < this.videoOptions.playbackCount
            ) {
              this.$refs[
                "class-video"
              ].currentTime = this.videoOptions.start_at;
              this.play();
            } else if (this.videoOptions.list_loop) {
              this.playNextVideo();
            }
          }
        }
      });

      video.addEventListener("canplay", () => {
        this.videoOptions.canplay = true;
        // 初始化音量
        video.volume = this.videoOptions.volume / 100;
        video.muted = this.videoOptions.muted;
      });

      //开始跳转进度条位置
      video.addEventListener("seeking", (e) => {
        if (this.videoOptions.palying) {
          e.target.pause();
        }
      });

      // 查找结束。当用户已经移动/跳跃到视频中新的位置时触发
      video.addEventListener("seeked", (e) => {
        e.target.play();
        if (!this.videoOptions.upd_process) {
          this.videoOptions.upd_process = true;
        }
      });

      // 播放结束
      video.addEventListener("ended", () => {
        this.videoOptions.palying = false;
        this.videoOptions.hasPlayedCnt++; // 增加播放次数计数
        if (
          (this.videoOptions.loop ||
            this.videoOptions.hasPlayedCnt < this.videoOptions.playbackCount) &&
          this.videoOptions.type == "video"
        ) {
          this.$refs["class-video"].currentTime = 0;
          this.play();
          return;
        }

        if (
          (this.videoOptions.loop ||
            this.videoOptions.hasPlayedCnt < this.videoOptions.playbackCount) &&
          this.videoOptions.type == "logic_seq"
        ) {
          this.$refs["class-video"].currentTime = this.videoOptions.start_at;
          this.play();
          return;
        }

        if (this.videoOptions.list_loop) {
          this.playNextVideo();
        }
      });

      // 获取视频总长度
      video.addEventListener("durationchange", () => {
        if (this.videoOptions.type == "video") {
          this.videoOptions.total_time = this.formatVideoTime(video.duration);
        } else {
          let start = this.videoOptions.start_at;
          let end = this.videoOptions.end_at;
          end = end >= video.duration ? video.duration : end;
          this.videoOptions.total_time = this.formatVideoTime(end - start);
        }

        this.videoOptions.process_dragable = true;
        // 手动播放模式下，切换视频源不自动播放
        if (this.videoOptions.list_loop) {
          this.$refs["class-video"].play();
        }
      });
    },
    getTotalSecsByCurrtime(currtime) {
      let arr = currtime.split(":");
      return (
        parseInt(arr[0] * 60 * 60) + parseInt(arr[1] * 60) + parseInt(arr[2])
      );
    },
    setCurrtime(src, poster, currtime, end_time) {
      this.videoOptions.type = "logic_seq";
      this.videoOptions.start_at = this.getTotalSecsByCurrtime(currtime);
      this.videoOptions.end_at = this.getTotalSecsByCurrtime(end_time);

      if (src != this.videoOptions.src) {
        this.videoOptions.src = src;
        this.videoOptions.poster = poster;
        this.videoOptions.palying = false;
        this.videoOptions.played_percent = 0;
        this.videoOptions.hasPlayedCnt = 0; // 重置播放次数
      }

      let start = this.videoOptions.start_at;
      let end = this.videoOptions.end_at;
      let duration = this.$refs["class-video"].duration;
      end = end > duration ? duration : end;
      this.videoOptions.total_time = this.formatVideoTime(end - start);

      this.$refs["class-video"].currentTime = this.getTotalSecsByCurrtime(
        currtime
      );
      this.play();
    },
    play() {
      let video = this.$refs["class-video"];
      if (!this.videoOptions.palying && this.videoOptions.canplay) {
        video.play();
      }
    },
    pause() {
      let video = this.$refs["class-video"];
      if (this.videoOptions.palying) {
        video.pause();
      }
    },
    videoBarClick(event) {
      if (!this.videoOptions.src) return;
      let video = this.$refs["class-video"];
      if (event == "play") {
        if (this.videoOptions.palying) {
          video.pause();
        } else {
          if (this.videoOptions.type == "logic_seq") {
            let currTime = video.currentTime;
            let end_at = this.videoOptions.end_at;
            end_at = end_at > video.duration ? video.duration : end_at;
            if (currTime >= end_at || currTime <= this.videoOptions.start_at) {
              video.currentTime = this.videoOptions.start_at;
            }
          }
          video.play();
        }
      } else if (event == "muted") {
        this.toggleMute();
      } else if (event == "maxmin") {
        this.videoOptions.full_screen = !this.videoOptions.full_screen;
      } else if (event == "loop") {
        this.videoOptions.loop = !this.videoOptions.loop;
      } else if (event == "list_loop") {
        this.videoOptions.list_loop = !this.videoOptions.list_loop;
      }
    },
  },
};
</script>

<style>
.playback-cnt-popover-class {
  width: 3.2rem !important;
  min-width: 0 !important;
}

/* 音量弹窗样式 */
.volume-popover,
.volume-popover-fullscreen {
  border-radius: 12px !important;
  border: none !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15) !important;
  padding: 0 !important;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%) !important;
}

.volume-popover-fullscreen {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 250, 252, 0.95) 100%) !important;
  backdrop-filter: blur(10px);
}

.volume-control-panel {
  padding: 16px;
  border-radius: 12px;
}

.volume-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  gap: 8px;
}

.volume-icon-wrapper {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: linear-gradient(135deg, #16a0e9 0%, #1890ff 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(22, 160, 233, 0.3);
}

.volume-icon-wrapper:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(22, 160, 233, 0.4);
}

.volume-icon {
  width: 16px !important;
  height: 16px !important;
  filter: brightness(0) invert(1);
}

.volume-text {
  color: #2c3e50;
  font-size: 14px;
  font-weight: 500;
  flex: 1;
}

.volume-percentage {
  color: #16a0e9;
  font-size: 14px;
  font-weight: 600;
  min-width: 40px;
  text-align: right;
}

.volume-slider-wrapper {
  position: relative;
}

.volume-slider {
  margin: 0 !important;
}

/* 自定义滑块样式 */
.volume-slider .el-slider__runway {
  height: 6px !important;
  background: linear-gradient(90deg, #e8f4fd 0%, #d1ecf1 100%) !important;
  border-radius: 3px !important;
}

.volume-slider .el-slider__bar {
  background: linear-gradient(90deg, #16a0e9 0%, #1890ff 100%) !important;
  border-radius: 3px !important;
  height: 6px !important;
}

.volume-slider .el-slider__button {
  width: 16px !important;
  height: 16px !important;
  background: #ffffff !important;
  border: 2px solid #16a0e9 !important;
  box-shadow: 0 2px 8px rgba(22, 160, 233, 0.3) !important;
  transition: all 0.3s ease !important;
}

.volume-slider .el-slider__button:hover {
  transform: scale(1.2) !important;
  box-shadow: 0 4px 12px rgba(22, 160, 233, 0.5) !important;
}

.volume-slider .el-slider__button-wrapper {
  width: 16px !important;
  height: 16px !important;
}

/* 弹窗箭头样式 */
.volume-popover[x-placement^="top"] .popper__arrow,
.volume-popover-fullscreen[x-placement^="top"] .popper__arrow {
  border-top-color: #ffffff !important;
}

.volume-popover[x-placement^="top"] .popper__arrow::after,
.volume-popover-fullscreen[x-placement^="top"] .popper__arrow::after {
  border-top-color: #ffffff !important;
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fadeIn {
  animation: fade-in 0.3s ease-in-out;
}

@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

video {
  object-fit: contain;
}
</style>
